<div [hidden]="hideSidebar" id="sidebar">
  <div>
    <span id="title">{{ "settings.settings" | transloco }}</span>

    <h3>{{ taxReturnAlias }}</h3>
    <div id="menu" class="ui list">
      <div
        [routerLink]="['global/questions']"
        [routerLinkActive]="['active']"
        class="item"
      >
        {{ "settings.global-questions-header" | transloco }}
      </div>
      <div
        [routerLink]="['global/builder']"
        [routerLinkActive]="['active']"
        class="item"
        data-testid="global-builder-link"
      >
        {{ 'settings.global-tax-return-alias-builder' | transloco: {taxReturnAlias} }}
      </div>
      <div
        [routerLink]="['questions']"
        [routerLinkActive]="['active']"
        class="item"
        data-testid="questions-link"
      >
        {{ "settings.questions-q-uppercase" | transloco }}
      </div>

      <div
        [routerLink]="['form/builder-year-select']"
        [routerLinkActive]="['active']"
        class="item"
      >
        {{ 'settings.tax-return-alias-builder' | transloco: {taxReturnAlias} }}
      </div>
      <div
        [attr.data-test-ref]="'calc'"
        [routerLink]="['calculations']"
        [routerLinkActive]="['active']"
        class="item"
      >
        {{ "settings.calculations" | transloco }}
      </div>
      <div
        [routerLink]="['tax-years']"
        [routerLinkActive]="['active']"
        class="item"
      >
        {{ 'settings.create-year-label' | transloco: {yearLabel} }}
      </div>
      <div
        [routerLink]="['types']"
        [routerLinkActive]="['active']"
        class="item"
      >
        {{ 'settings.tax-return-alias-types' | transloco: {taxReturnAlias} }}
      </div>
      @if (isSmartFormsEnabled) {
      <div
        [routerLink]="['smartFormTypes']"
        [routerLinkActive]="['active']"
        class="item"
      >
        Smart Form Types
      </div>
      } @if (isSmartFormsEnabled) {
      <div
        [routerLink]="['smartForm/builder-year-select']"
        [routerLinkActive]="['active']"
        class="item"
      >
        Smart Form Builder
      </div>
      }
    </div>

    <h3>{{ "settings.client-rules" | transloco }}</h3>
    <div class="ui list">
      <div
        [routerLink]="['client-rules/questions']"
        [routerLinkActive]="['active']"
        class="item"
        data-testid="client-questions-link"
      >
        {{ "settings.questions-q-uppercase" | transloco }}
      </div>
      <div
        [routerLink]="['client-rules/builder-year-select']"
        [routerLinkActive]="['active']"
        class="item"
        data-testid="client-rules-builder-link"
      >
        {{ "settings.client-rules-builder" | transloco }}
      </div>
    </div>

    <h3>{{ "settings.other" | transloco }}</h3>
    <div class="ui list">
      <div
        [routerLink]="['sources']"
        [routerLinkActive]="['active']"
        class="item"
      >
        {{ "settings.sources" | transloco }}
      </div>
      <div
        [routerLink]="['templates']"
        [routerLinkActive]="['active']"
        class="item"
      >
        {{ "settings.templates" | transloco }}
      </div>
      <div
        [routerLink]="['config-import']"
        [routerLinkActive]="['active']"
        class="item"
      >
        {{ "settings.config-import" | transloco }}
      </div>
      <!-- TRANSLOCO TODO -->
      <div
        [routerLink]="['atlas-import']"
        [routerLinkActive]="['active']"
        class="item"
      >
        Atlas Import
      </div>
      <!-- END OF TRANSLOCO TODO -->
      @if (!isProductionMode) {
      <div
        [routerLink]="['archived-configs']"
        [routerLinkActive]="['active']"
        class="item"
      >
        {{ "settings.Archived-Configs" | transloco }}
      </div>
      }
    </div>

    <div>
      <h3>{{ "settings.access" | transloco }}</h3>
      <div class="ui list">
        <div
          [routerLink]="['users']"
          [routerLinkActive]="['active']"
          class="item"
        >
          {{ "settings.users" | transloco }}
        </div>
        @if (userInfo.isSuperAdmin) {
        <div
          [routerLink]="['countries']"
          [routerLinkActive]="['active']"
          class="item"
        >
          {{ 'settings.countries' |  transloco: {countryAlias} }}
        </div>
        }
      </div>
    </div>
  </div>

  <div
    (click)="syncCache()"
    class="ui primary button"
    [ngClass]="{ loading: isSyncingCache }"
  >
    {{ "settings.sync-cache" | transloco }}
  </div>
</div>

<div id="content">
  <router-outlet></router-outlet>
</div>
